import { ASSET_CFG_KEY } from "../../core/constants";
import { store } from "../../core/state";
import { requestAssetsI18nFile } from "../requests";

export async function loadAssetsI18n(path, lang) : Promise<void> {
  const localStorageKey = `assets_${lang}`;
  store.setState(ASSET_CFG_KEY, { });
  let assetCfgState = store.getState(ASSET_CFG_KEY);

  // Falls nicht im store, versuche aus localStorage zu laden
  if (!assetCfgState) {
    const storedData = JSON.parse(localStorage.getItem(localStorageKey));
    if (storedData) {
      store.setState(ASSET_CFG_KEY, storedData);
      assetCfgState = storedData;
    }
  }

  if (assetCfgState && assetCfgState.initialized === true) {
    return;
  }

  const assetsFilePath = `${path}/assets_${lang}.json`
  const data = await requestAssetsI18nFile(assetsFilePath);
  
  // Wenn keine Daten erhalten wurden, breche ab
  if (!data) return;

  data.initialized = true;
  store.setState(ASSET_CFG_KEY, { ...data });
  localStorage.setItem(localStorageKey, JSON.stringify(data));

  console.log(`Loaded Asset Configuration for language: ${lang}`);
}

export const translateAssetKey = (key) => {
  const assetCfgState = store.getState(ASSET_CFG_KEY);

  // Suche nach dem key und gebe den zugehörigen Wert zurück
  const asset = assetCfgState.getValue().assetsMap.find(asset => asset.key === key);
  return asset ? asset.value : key;
}

export const getKeyForAsset = (name) => {
  const assetCfgState = store.getState(ASSET_CFG_KEY);

  // Suche nach dem Wert und gebe den zugehörigen Schlüssel zurück
  const asset = assetCfgState.getValue().assetsMap?.find(asset => asset.value === name);
  return asset ? asset.key : name;
}
